import React from 'react'
import styles from './UserMenu.module.scss'
import userpickimg from 'assets/userpickimg.png'
import { Menu } from '../Menu/Menu'

type Props = {
    onOpenEditPage: () => void,
}

export function UserMenu(props: Props): JSX.Element {
    const [showMenu, setShowMenu] = React.useState(false)
    const containerRef = React.useRef(null)

    function openMenu() {
        setShowMenu(!showMenu)
    }

    const handleOutsideClick = (event) => {
        if (containerRef.current && !containerRef.current.contains(event.target)) {
            setShowMenu(false)
        }
    }


    React.useEffect(() => {
        window.addEventListener('click', handleOutsideClick)

        return () => {
            window.removeEventListener('click', handleOutsideClick)
        }
    }, [])

    return (
        <div className={styles['wrapper']} ref={containerRef}>
            <div className={styles['button']} onClick={openMenu}>
                <img src={userpickimg} alt='user' />
            </div>
            {showMenu && (
                <div className={styles['menu']}>
                    <Menu onOpenEditPage={props.onOpenEditPage} />
                </div>
            )}
        </div>
    );
}

